<template>
  <v-card flat class="fid-card">
    <v-toolbar>
      <v-toolbar-title v-if="sectionHeading">
        <span>{{ sectionHeading }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span text-xs-right v-if="bigEnough">
        <v-switch
          v-model="compressModel"
          prepend-icon="short_text"
        >
        </v-switch>
      </span>
      <hide-detail 
        prop-name="hideContent"
        tooltip="credits"
        left
        :hide="hideContent"
        @hide="hide"
      ></hide-detail> 

    </v-toolbar>
    <content-details v-if="!hideContent"
      :row-types="rowTypes"
      :item="item"
      :compressed="this.compressModel"
      :all-prizes="allPrizes">
    </content-details>
  </v-card>
</template>
<script>
import Contentdetails from '@/components/Contentdetails'
import Hidedetail from '@/components/Hidedetail'
import { Controls } from '@/gql'
import { mergeControls } from '@/js/apollo'
export default {
  components: {
    'content-details': Contentdetails,
    'hide-detail': Hidedetail
  },
  props: {
    rowTypes: {
      type: Array,
      requireed: true
    },
    item: {
      type: Object
    },
    allPrizes: Array,
    contentHeading: String
  },
  data: () => ({
    hideContent: false,
    compressed: false,
    Controls: {}
  }),
  computed: {
    playing () {
      return this.Controls && this.Controls.playing
    },
    sectionHeading () {
      return this.contentHeading || 'Credits'
    },
    // this convoluted model is because I need to see the state of the
    // vuetify breakpoints to set the default value, but can't until mounted
    // TODO - should this be a global setting for each page handled by state?
    compressModel: {
      get () {
        return this.compressed && this.bigEnough
      },
      set () {
        this.compressed = !this.compressed
      }
    },
    bigEnough () {
      return this.$vuetify.breakpoint.mdAndUp
    }
  },
  methods: {
    hide (pack) {
      this[pack.propName] = pack.hide
    },
    stopPlaying () {
      mergeControls({
        playing: ''
      })
    }
  },
  apollo: {
    Controls: {
      query: Controls
    }
  }
}
</script>
